import { render, staticRenderFns } from "./CreateServiceLocal.vue?vue&type=template&id=6de5fc16&scoped=true"
import script from "./CreateServiceLocal.vue?vue&type=script&lang=js"
export * from "./CreateServiceLocal.vue?vue&type=script&lang=js"
import style0 from "./CreateServiceLocal.vue?vue&type=style&index=0&id=6de5fc16&prod&lang=scss&scoped=true"
import style1 from "./CreateServiceLocal.vue?vue&type=style&index=1&id=6de5fc16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de5fc16",
  null
  
)

export default component.exports